import React from "react";
import { Redirect, Route, withRouter } from "react-router-dom";
import "./App.css";
import Config from "./Config";
import "./lato_font/Lato-Bold.ttf";
import "./lato_font/Lato-Regular.ttf";
import AppLoadingDialog from "./ui/dialog/app_loading_dialog";
import LoginScreen from "./ui/screen/login_screen/login_screen";
import connectivity_screen from "./ui/screen/connectivity_screen";
import ClientDetailsScreen from "./ui/screen/client_details_screen/client_details_screen";
import DocumentsScreen from "./ui/screen/documents_screen/documents_screen";
import SuccessfulRegistrationScreen from "./ui/screen/successful_registration_screen/successful_registration_screen";
import OtpScreen from "./ui/screen/otp_screen/otp_screen";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      client: Config.context,
      isLoggedIn: false,
    };
  }

  async componentDidMount() {
    //await this.checkSession();
    this.setState({
      loading: false,
    });
  }

  redirectToLogin() {
    // window.location.href = `/${Config.context}/${Config.routes.generic.login}`;
    this.props.history.push(
      `/${this.state.client}/${Config.routes.generic.login}`
    );
  }

  redirectToDashboard() {
    // window.location.href = `/${Config.context}/${Config.routes.generic.login}`;
    this.props.history.push(
      `/${this.state.client}/${Config.routes.generic.dashboard}`
    );
  }

  //The loading state for the screen
  loadingContent() {
    return (
      <div style={{ height: "100%", width: "100%" }}>
        <AppLoadingDialog isLoading={this.state.loading} />
      </div>
    );
  }

  //The paths setup to determine which screen to display
  appContent() {
    return (
      <>
        <Route exact path={`/${this.state.client}`} component={LoginScreen} />
        <Route exact path={`/${this.state.client}/login`} component={LoginScreen} />
        {/* Admin section urls */}


        {/* Quotation Steps */}
        {/*  <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.quotation_personal_details}`}
          component={PersonalDetailsScreen}
        /> */}

        {/* <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.quotation_product_selection}`}
          component={ProductSelectionScreen}
        /> */}

        {/* With ID */}

        {/* End Quotation Steps */}
        {/* Proposal Steps */}
        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.client_details_screen}/:type?/:action?`}
          component={ClientDetailsScreen}
        />

        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.member_details_screen}/:type?/:action?`}
          component={ClientDetailsScreen}
        />

        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.otp_screen}`}
          component={OtpScreen}
        />

        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.successful_registration}/:type?`}
          component={SuccessfulRegistrationScreen}
        />

        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.documents_screen}/:action?`}
          component={DocumentsScreen}
        />

        {/* End Proposal Steps */}

        <Route
          exact
          path={`/${this.state.client}/connectivity`}
          component={connectivity_screen}
        />

        <Route
          exact
          path="/"
          render={() => {
            return (
              <Redirect
                to={`/${this.state.client}/${Config.routes.generic.contact}`}
              />
            );
          }}
        />
        {/* ---------- End : Enhanced Route Paths ---------- */}
      </>
    );
  }

  render() {
    return this.state.isLoggedIn === false
      ? this.appContent()
      : this.redirectToLogin();
  }
}

export default withRouter(App);
